<template>
  <div class="container container-global">
    <h2>Le patch</h2>
    <div class="content">
      <p>
        contraception estroprogestative
        <br />
        Non remboursé
      </p>
      <br />
      <span>Mode d’efficacité sur 3 niveaux </span>
      <ul>
        <li>
          axe hypothalomo-hypophysaire - action principale : effet antigonadrope
          =inhibition de la sécrétion des gonadotrophines et blocage de
          l’ovulation
        </li>
        <li>endomètre : atrophie de l’endomètre</li>
        <li>
          glaire cervicale : la glaire devient imperméable à la migration des
          spermatozoïdes
        </li>
      </ul>
      <span>Comment la prescrire ? </span>
      <br />
      <br />
      <p>
        A placer sur peau saine (fesse, abdomen, face extérieure de la partie
        supérieure du bras ou partie supérieure du torse hormis les seins).
        <br />
        <br />
        A initier classiquement au premier jour des règles.
        <br />
        <br />
        Quant au « quickstart », il consiste en une initiation à n’importe quel
        jour du cycle (en s’assurant de l’absence de grossesse), mais ne montre
        son efficacité qu’au bout du 7ème jour (méthodes barrières dans
        l’intervalle)
        <br />
        <br />
        Schéma discontinu : à changer toutes les semaines pendant 3 semaines,
        puis retrait pendant une semaine.
        <br />
        <br />
        Ne doit pas être retiré ou décollé plus de 24h sinon diminution de son
        efficacité
      </p>
      <br />
      <span>Efficacite</span>
      <br />
      <br />
      <p>Indice de Pearl : 0,3% si utilisation optimale, 8% en vie réelle</p>
      <br />
      <span>avantage :</span>
      <br />
      <br />
      <p>meilleure observance</p>
      <br />
      <span>Contre-indications absolues </span>
      <br />
      <br />
      <p>
        Accident thromboembolique veineux ou artériel (actuel ou antécédent)
        <br />
        Thrombophilie congénitale ou acquise Migraine avec aura quelque soit
        l’âge
        <br />
        Tabagisme après 35 ans
        <br />
        HTA non contrôlée
        <br />
        Diabète compliqué de micro ou macroangiopathie
        <br />
        Dyslipidémie sévère
        <br />
        Tumeurs hépatiques et hépatopathies sévères
        <br />
        Cancer estrogénodépendant
        <br />
        Allaitement maternel en cours
        <br />
        3 premières semaines du post partum
        <br />
        poids supérieur à 90kg
        <br />
        réactions cutanées locales.
      </p>
      <br />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
